import { atom } from 'recoil';
import { FeedbackMappedType, PinStateAtomType, TutorStateAtomType } from 'src/types/generic';
import {
  ICheckExerciseResponseType,
  IConversations,
  IStartConversationPayloadType,
} from 'src/types/serviceResponseTypes';

export const promptAtom = atom({
  key: 'prompt',
  default: '',
});

export const userContentAtom = atom({
  key: 'userContent',
  default: '',
});

export const conversationsAtom = atom({
  key: 'conversations',
  default: {
    loading: true,
    data: {} as IConversations,
    error: '',
  },
});

export const checkExerciseAtom = atom({
  key: 'checkExerciseAtom',
  default: {
    loading: true,
    data: {} as ICheckExerciseResponseType,
    error: '',
  },
});

export const feedbackAtom = atom({
  key: 'feedbackAtom',
  default: [] as FeedbackMappedType[],
});

export const accessTokenAtom = atom({
  key: 'accessToken',
  default: process.env.REACT_APP_ACCESS_TOKEN ?? '',
});

export const frameParamsAtom = atom({
  key: 'frameParamsAtom',
  default: {} as IStartConversationPayloadType,
});

export const tutorStateAtom = atom({
  key: 'tutorStateAtom',
  default: {} as TutorStateAtomType,
});

export const pinAtom = atom({
  key: 'pinsStateAtom',
  default: {} as PinStateAtomType,
});

export const pinWindowAtom = atom({
  key: 'pinWindowStateAtom',
  default: false,
});

export const pinMinimizeAtom = atom({
  key: 'pinMinimizeStateAtom',
  default: false,
});

export const explanationPinAtom = atom({
  key: 'explanationPinAtom',
  default: [] as string[],
});

export const selectedLangAtom = atom({
  key: 'selectedLangAtom',
  default: '',
});
